// components/WhatsAppButton.js
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

const WhatsAppButton = () => {
  const location = useLocation();
  // Don't show the WhatsApp floating button on management (gestion) pages
  if (location) {
    const path = location.pathname || '';
    const gestionPrefixes = [
      '/Gestion_Produit', '/Edit-stock', '/Edit-price', '/client-admin', '/dashbord-gestion',
      '/Caisse', '/historique', '/gestion-credits', '/facturations', '/parametres',
      '/Stock_Management', '/produits-admin', '/dashbord-admin', '/admin-announcement', '/order-admin', '/payment-admin'
    ];
    const isGestion = gestionPrefixes.some(p => path === p || path.startsWith(p + '/')) || path.toLowerCase().includes('/gestion');
    if (isGestion) return null;
  }
  const phoneNumber = '+212607164519'; // Replace with your full WhatsApp number (no + or spaces)

  const message = 'Bonjour, je veux plus d\'informations.';
  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '20px',
left: '20px',
        backgroundColor: '#25D366',
        color: '#fff',
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '30px',
        zIndex: 1000,
        boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
        cursor: 'pointer'
      }}
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppButton;
